import DeletePortfolioModal from './DeletePortfolioModal';

export default DeletePortfolioModal;
